export const promisify = (fn: Function) => {
  return (args) => {
    return new Promise(function (resolve, reject) {
      fn({
        ...args,
        success: (res) => resolve(res),
        fail: (err) => reject(err),
      });
    });
  };
};

export const isUndefined = (v) => typeof v === 'undefined';

export const getWin = () => window;

export const getVariable = (key: string) => {
  const injectInfo = (getWin() as any).injectInfo || {};
  return injectInfo[key];
};

/**
 * @input
 *
 * [
 *  { Content-Type: 'application/json'},
 *  { appId: 'abcd' }
 * ]
 *
 * @result
 *
 * {
 *    Content-Type: 'application/json',
 *    appId: 'abcd'
 * }
 */

export const arrayToObject = (arr: Record<string, any>[]) => {
  if (!Array.isArray(arr)) {
    return arr;
  }
  const result: Record<string, any> = {};
  arr.forEach((obj) => {
    for (const k in obj) {
      result[k] = obj[k];
    }
  });
  return result;
};

/**
 * 识别 path 是否 / 开头或结尾，并自动补齐
 */
export const autoAppendSlash = (path: string) => {
  if (!path) return '';

  // 自动补齐 /
  if (path && path[0] != '/') {
    return '/' + path;
  }
  return path;
}

/**
 * 识别 path 是否 / 开头或结尾，并自动删除 /
 */
export const autoSliceSlash = (path: string) => {
  if (!path) return '';

  // 自动删除 /
  if (path && path[0] === '/') {
    return path.slice(1);
  }
  return path;
}
